import {collapsedLists, openNotificationsButton, removeButton, state} from "../index";
import {renderNotificationElement} from "../utils";
import {Api} from "../../api/api";
import {formattingDate} from "../../utils/common";
import {getDateItemListTemplate} from "../templates";
import NotificationsState from "../notifications-state/notifications-state";
import {NotificationButton} from "../notification-button/notification-button";
import {NotificationRemoveButton} from "../../../../types/frontend/js/notifications/notification-remove-button";

type NotificationElement = {element: HTMLElement, isToday: boolean}

class NotificationFullList {
  private api = new Api();
  private collapsedLists: Map<any, any>;
  private readonly element: HTMLElement;
  private itemElements: Map<string, NotificationElement> = new Map();
  private state: NotificationsState;
  private openNotificationsButton: NotificationButton;
  private readonly removeButton: NotificationRemoveButton;

  constructor(element: HTMLElement) {
    this.element = element;

    this.state = state;

    this.collapsedLists = collapsedLists;

    this.openNotificationsButton = openNotificationsButton;

    this.removeButton = removeButton;

    this.onListClick = this.onListClick.bind(this);
    this.removeAllElements = this.removeAllElements.bind(this);

    this.element.addEventListener(`click`, this.onListClick);
  }

  setNewDateList(date: string, isPrepend: boolean) {
    if (this.itemElements.has(date)) {
      this.checkTodayDate(date);
      return;
    }

    const element = renderNotificationElement(this.element, getDateItemListTemplate(date), isPrepend) as HTMLElement;
    this.itemElements.set(date, {element, isToday: this.getIsTodayDay(date)});
  }

  getSubListElement(date: string): HTMLElement {
    return this.itemElements.get(date)!.element.querySelector(`.js-notification-sub-list`) as HTMLElement;
  }

  getItemElementChildrenLength(date: string) {
    return this.itemElements
      .get(date)!.element
      .querySelector(`.js-notification-sub-list`)!
      .children.length;
  }

  removeItemElement(date: string) {
    this.itemElements.get(date)!.element.remove();
    this.itemElements.delete(date);
  }

  async removeNotification(target: HTMLElement) {
    const notificationElement = target.closest(`.js-notification`) as HTMLElement;
    const notificationId = +notificationElement.dataset.notificationId!;

    const result = await this.api.customQuery(`/notifications/delete?id=${notificationId}`, {});
    // const result = await this.api.customQuery(`/data/remove-notification.json?id=${notificationId}`, {});

    if (result.status === 200) {
      const taskId = +(notificationElement.closest(`[data-n-task-id]`)! as HTMLElement).dataset.nTaskId!;
      const date = (notificationElement.closest(`[data-notification-date]`) as HTMLElement).dataset.notificationDate!;

      const taskView = this.state.getState()
        .get(taskId)!.view;

      taskView.decreaseCount();
      taskView.updateCountElement();

      this.state.removeNotification(taskId, notificationId);

      notificationElement.remove();

      if (this.getItemElementChildrenLength(date) < 1) {
        this.removeItemElement(date);
      }

      if (this.removeButton) {
        this.state.decreaseLength(1);
        this.removeButton.setCount(this.state.getLength());
      }

      if (this.state.getState().size === 0) {
        this.openNotificationsButton.setIsNewStatus();

        if (this.removeButton) {
          this.removeButton.hideButton();
        }
      }
    }
  }

  private getIsTodayDay(date: string) {
    const formattedDate = new Date(date);
    const today = new Date();

    return `${formattedDate.getUTCFullYear()}-${formattedDate.getUTCMonth()}-${formattedDate.getUTCDate()}` ===
      `${today.getUTCFullYear()}-${today.getUTCMonth()}-${today.getUTCDate()}`;
  }

  private checkTodayDate(date) {
    const element = this.itemElements.get(date);

    if (element?.isToday && !this.getIsTodayDay(date)) {
      element.isToday = false;

      this.changeDateTextContent(element, date);
    }
  }

  private changeDateTextContent(itemElement: NotificationElement, date: string) {
    itemElement.element.querySelector(`.notifications__date`)!.textContent = formattingDate(new Date(date));
  }

  removeAllElements() {
    this.element.replaceChildren();
    this.itemElements.clear();
  }

  async onListClick(evt: Event) {
    const target = evt.target as HTMLElement;

    if (target.classList.contains(`js-notification-remove`) || target.closest(`.js-notification-remove`)) {
      await this.removeNotification(target);
    }
  }
}

export default NotificationFullList;
